import { render, staticRenderFns } from "./DetalleClientes.vue?vue&type=template&id=c3b81d26&"
import script from "./DetalleClientes.vue?vue&type=script&lang=ts&"
export * from "./DetalleClientes.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleClientes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c3b81d26', component.options)
    } else {
      api.reload('c3b81d26', component.options)
    }
    module.hot.accept("./DetalleClientes.vue?vue&type=template&id=c3b81d26&", function () {
      api.rerender('c3b81d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaCliente/Editar/DetalleClientes.vue"
export default component.exports